const ScopeComponent = (Component) => {
  if (!Component.mounted) {
    Component.mounted = [];
  } else if (!Array.isArray(Component.mounted)) {
    Component.mounted = [Component.mounted];
  }
  Component.mounted.push(function() {
    this.$el.setAttribute(`data-v-${"fc06e39"}`, "");
  });
};
export {
  ScopeComponent as S
};
//# sourceMappingURL=ScopeComponent-CC0LPlVx.mjs.map
